import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import { useLang } from "../Utility/Languagecontext";
import { EASE, MaskLine, Reveal } from "../Utility/Motion";

// قسم "إزاي الشراء على الخارطة بيتم" في الهوم: 6 خطوات مختصرة + رابط للدليل الكامل
export const MainHowItWorks = () => {
  const { t, locale } = useLang();
  const h = t.howItWorks;
  const steps = t.guidePage.steps;
  const headRef = useRef(null);
  const headIn = useInView(headRef, { amount: 0.3 });
  const pad = (v) => v.toLocaleString(locale, { minimumIntegerDigits: 2, useGrouping: false });

  return (
    <section className="how" id="how-it-works">
      <div className="how__head" ref={headRef}>
        <div>
          <p className="how__label">{h.label}</p>
          <h2 className="how__title">
            {h.title.map((line, i) => (
              <MaskLine key={line} show={headIn} delay={i * 0.14}>
                {line}
              </MaskLine>
            ))}
          </h2>
        </div>
        <Reveal as="p" className="how__sub" delay={0.2}>
          {h.sub}
        </Reveal>
      </div>

      <ol className="how__grid">
        {steps.map((s, i) => (
          <motion.li
            key={s.title}
            className="how__step"
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.07 * (i % 3), ease: EASE }}
          >
            <span className="how__no">{pad(i + 1)}</span>
            <h3 className="how__step-title">{s.title}</h3>
            <p className="how__step-text">{s.text}</p>
          </motion.li>
        ))}
      </ol>

      <Reveal className="how__foot">
        <Link to="/off-plan-guide" className="btn btn--ghost">
          {h.cta}
        </Link>
      </Reveal>
    </section>
  );
};
